module.exports = __webpack_public_path__ + "static/media/copyright.285bba88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/icon/copyright.svg
// module id = 83
// module chunks = 0